import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import Icon from '@material-ui/core/Icon'

import formatPrice from '../../../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'

import placeholderImage from '../../../../assets/images/placeholder-image.png'

import '../../../../styles/css/base/popover.css'

import _ from 'lodash'
import yn from 'yn'

class BkFlowConfirmationRoomCard extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			urlData,
			hotelDescriptiveInfoData,
			activeCurrencyData,
			reservations,
			reservationKey
		} = this.props

		let activeHotelCode = null
		let matchedProperty = null
		let isTaxInclusiveProperty = false
		let renderRoomImage = ''
		let renderAdults = null
		let renderChildren = null
		let renderEnhancements = []
		let reservation = null
		let adults = urlData.adults
		let children = urlData.children
		let displayedPriceFrequency = 'per stay'


		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})
		}

		if (
			!_.isEmpty(matchedProperty) &&
			matchedProperty.displayPricesTaxInclusive
		) {
			isTaxInclusiveProperty = matchedProperty.displayPricesTaxInclusive
		}

		if (
			!_.isEmpty(matchedProperty) &&
			matchedProperty.displayPricesTimeline
		) {
			displayedPriceFrequency = matchedProperty.displayPricesTimeline
		}

		if (reservations.hotelResModifies) {
			reservation = reservations.hotelResModifies
		} else {
			reservation = reservations
		}

		// localSession data for guests / pets
		let flowGuestData = null

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		const hotelLabels = configData.hotel.labels[0]

		const totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')

		let confirmationId = null
		let arrivalDate = null
		let departureDate = null
		let nights = null
		let roomTypeName = null
		let roomTypeCode = null
		let cancellation = null
		let enhancements = null
		let roomImage = placeholderImage
		let roomRate = null
		let currencyCode = 'USD'
		let currencySymbol = getCurrencySymbol(currencyCode)

		// CURRENT RESERVATION DATA
		if (
			reservation &&
			reservation[reservationKey]
		){
			const currentReservation = reservation[reservationKey]

			// CONFIRMATION OR ITINERARY NUMBER
			if (
				currentReservation.uniqueId &&
				currentReservation.uniqueId.id
			) {
				confirmationId = currentReservation.uniqueId.id
			}

			// CURRENT ROOM STAYS DATA
			if (
				currentReservation.roomStays &&
				currentReservation.roomStays[0]
			) {
				const currentRoomStays = currentReservation.roomStays[0]

				// ARRIVAL
				if (
					currentRoomStays.timeSpan &&
					currentRoomStays.timeSpan.start
				) {
					arrivalDate = currentRoomStays.timeSpan.start
				}

				// DEPARTURE
				if (
					currentRoomStays.timeSpan &&
					currentRoomStays.timeSpan.end
				) {
					departureDate = currentRoomStays.timeSpan.end
				}

				// NIGHTS
				if (
					arrivalDate &&
					departureDate
				) {
					nights = moment(departureDate).diff(moment(arrivalDate), 'days')
				}

				// CURRENT ROOM TYPE DATA
				if (
					currentRoomStays &&
					currentRoomStays.roomTypes &&
					currentRoomStays.roomTypes[0]
				) {
					const roomType = currentRoomStays.roomTypes[0]

					// Current room type name
					if (
						roomType.roomDescription &&
						roomType.roomDescription.name
					) {
						roomTypeName = roomType.roomDescription.name
					}

					// Current room type code
					if (roomType.roomTypeCode) {
						roomTypeCode = roomType.roomTypeCode
					}

					if (
						roomType.viewExtensions &&
						!_.isEmpty(roomType.viewExtensions) &&
						roomType.viewExtensions.roomTypeImages &&
						roomType.viewExtensions.roomTypeImages[0] &&
						roomType.viewExtensions.roomTypeImages[0].path
					) {
						roomImage = roomType.viewExtensions.roomTypeImages[0].path
					}
				}

				// Current rate plan data
				if (
					currentRoomStays &&
					currentRoomStays.ratePlans &&
					currentRoomStays.ratePlans[0]
				) {
					const currentRatePlans = currentRoomStays.ratePlans[0]

					// Current room cancellation policy
				  if (_.get(currentRatePlans, 'cancelPenalties[0].penaltyDescription.text')) {
					  cancellation = currentRatePlans.cancelPenalties[0].penaltyDescription.text
				  }
				}

				// Current room rate data
				if (
					currentRoomStays.roomTypes &&
					currentRoomStays.roomTypes[0] &&
					currentRoomStays.roomTypes[0].viewExtensions &&
					currentRoomStays.roomTypes[0].viewExtensions.roomRates
				) {
					const currentRoomRates = currentRoomStays.roomTypes[0].viewExtensions.roomRates[0]

					// Calculate average room rate for reservation
					if (_.get(currentRoomRates, 'rates[0].total.amountBeforeTax') || _.get(currentRoomRates, 'rates[0].total.amountAfterTax')) {
						if (displayedPriceFrequency === 'per stay') {
							if (isTaxInclusiveProperty) {
								roomRate = formatPrice(currentRoomRates.rates[0].total.amountAfterTax, 2, false)
							} else {
								roomRate = formatPrice(currentRoomRates.rates[0].total.amountBeforeTax, 2, false)
							}
						} else if (totalNights) {
							if (isTaxInclusiveProperty) {
								roomRate = formatPrice(currentRoomRates.rates[0].total.amountAfterTax / totalNights, 2, false)
							} else {
								roomRate = formatPrice(currentRoomRates.rates[0].total.amountBeforeTax / totalNights, 2, false)
							}
						}
					}

					// Currency Code for current reservation room
					if (_.get(currentRoomRates, 'rates[0].base.currencyCode')) {
						currencyCode = currentRoomRates.rates[0].base.currencyCode
					}
				}
			}

			if (currentReservation.services) {
				enhancements = currentReservation.services
			}
		}

		// Initialize hotelDescriptiveInfo variables
		let unrefinedGuestRoom = null

		// Initialize and set hotelDescriptiveInfo data if matched
		if (
			yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
			!_.isEmpty(
				hotelDescriptiveInfoData &&
				hotelDescriptiveInfoData.FacilityInfo &&
				hotelDescriptiveInfoData.FacilityInfo.GuestRooms
			)
		) {
			unrefinedGuestRoom = hotelDescriptiveInfoData.FacilityInfo.GuestRooms.filter(function(room) {
				return room.Code === roomTypeCode
			})
		}

		function isEnhancementTitle(title) {
			return title.name === 'Title'
		}

		// Calculated exchange format for symbol and code
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			currencyCode = activeCurrencyData.currencyCode

			if (activeCurrencyData.currencySymbol) {
				currencySymbol = activeCurrencyData.currencySymbol
			} else {
				currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}

			if (
				_.get(reservation, '[reservationKey].roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountBeforeTax') ||
				_.get(reservation, '[reservationKey].roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountAfterTax')
			) {
				if (displayedPriceFrequency === 'per stay') {
					if (isTaxInclusiveProperty) {
						roomRate = formatPrice(reservation[reservationKey].roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate, 2, false)
					} else {
						roomRate = formatPrice(reservation[reservationKey].roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountBeforeTax * activeCurrencyData.exchangeRate, 2, false)
					}
				} else if (totalNights) {
					if (isTaxInclusiveProperty) {
						roomRate = formatPrice(reservation[reservationKey].roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountAfterTax / totalNights * activeCurrencyData.exchangeRate, 2, false)
					} else {
						roomRate = formatPrice(reservation[reservationKey].roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountBeforeTax / totalNights * activeCurrencyData.exchangeRate, 2, false)
					}
				}
			}
		}


		// Construct image or placeholder
		if (
			process.env.REACT_APP_COMPONENT_BASE_CRS_DATA &&
			!_.isEmpty(unrefinedGuestRoom)
		) {
			// Use OtaHotelDescriptiveInfo data > availabilityData and Mediated assets
			renderRoomImage = (
				<div
					className="bk-flow-confirmation__room-image u-bg-image"
					style={{ backgroundImage: 'url(' + unrefinedGuestRoom[0].MultimediaDescriptions.ImageItems[0] + ')' }}
				>
					<img
						className="u-element-hidden"
						src={ unrefinedGuestRoom[0].MultimediaDescriptions.ImageItems[0] }
						alt="Coming Soon"
					/>
				</div>
			)
		} else if (roomImage) {
			renderRoomImage = (
				<div
					className="bk-flow-confirmation__room-image u-bg-image"
					style={{ backgroundImage: 'url(' + roomImage + ')' }}
				>
					<img
						className="u-element-hidden"
						src={ roomImage }
						alt="Coming Soon"
					/>
				</div>
			)
		}

		// set adults by flowGuestData
		if (flowGuestData && flowGuestData[reservationKey].adults) {
			adults = flowGuestData[reservationKey].adults
		}

		// set children by flowGuestData
		if (flowGuestData && flowGuestData[reservationKey].children) {
			children = flowGuestData[reservationKey].children
		}

		// Construct adults
		if (adults === 1) {
			renderAdults = <span>{ adults } { hotelLabels.adult }</span>
		} else if (adults > 1) {
			renderAdults = <span>{ adults } { hotelLabels.adults }</span>
		}

		// Construct children
		if (children === 1) {
			renderChildren = <span>{ children } { hotelLabels.children }</span>
		} else if (children > 1) {
			renderChildren = <span>{ children } { hotelLabels.child }</span>
		}

		if (!_.isEmpty(enhancements)) {

			// sort out unique entries by serviceInventoryCode
			const uniqueEnhancements = _.uniqBy(enhancements, 'serviceInventoryCode')

			// Loop confirmation services and build renderEnhancements
			for (let enhancementKey in uniqueEnhancements) {
				renderEnhancements.push(
					<p
						className="bk-flow-confirmation__room-data-enhancement u-remove-margin"
						key={ uniqueEnhancements[enhancementKey].serviceDetails.comments.find(isEnhancementTitle).text + '-' + reservationKey }
					>
						{ uniqueEnhancements[enhancementKey].serviceDetails.comments.find(isEnhancementTitle).text }:&nbsp;
						{ currencySymbol }
						{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
							activeCurrencyData &&
							activeCurrencyData.exchangeRate ?
							formatPrice(uniqueEnhancements[enhancementKey].price[0].base.amountBeforeTax * activeCurrencyData.exchangeRate)
						:
							formatPrice(uniqueEnhancements[enhancementKey].price[0].base.amountBeforeTax)
						}&nbsp;
						{ currencyCode }/{ uniqueEnhancements[enhancementKey].servicePricingType }
					</p>
				)
			}
		} else {
			renderEnhancements.push('--')
		}

		return (
			<div className="bk-flow-confirmation__room-card" key={ reservationKey }>

				{ renderRoomImage }

				<div className="bk-flow-confirmation__room-data u-bg-white">
					<h3>
						{ hotelLabels.room } { Number(reservationKey) + 1 }: { roomTypeName ? roomTypeName : '--' }
					</h3>

					<p className="bk-flow-confirmation__confirmation-number">
						<span className="u-font-bold">{ hotelLabels.confirmation + ': '}</span>
						{ confirmationId ?
							confirmationId
						:
							'--'
						}
					</p>

					<p className="bk-flow-confirmation__room-data-row row u-font-medium">
						<span className="u-font-bold">{ hotelLabels.guests }:&nbsp;</span>
						{ renderAdults }
						{ renderChildren }
					</p>

						<p className="bk-flow-confirmation__room-data-row row u-font-medium">
						<span className="u-font-bold">{ hotelLabels.nights }:&nbsp;</span>
						{ nights ?
							nights
						:
							'--'
						}
					</p>

					<p className="bk-flow-confirmation__room-data-row row u-font-medium">
						<span className="u-font-bold">{ hotelLabels.rate }:&nbsp;</span>
						{ roomRate ?
							currencySymbol + roomRate + ' ' + currencyCode + '/' + hotelLabels.night
						:
							'--'
						}
					</p>

					<div className="bk-flow-confirmation__room-data-row row u-font-medium">
						<span className="u-font-bold">{ hotelLabels.formattedAddons }:&nbsp;</span>
						{ renderEnhancements }
					</div>

					{ yn(process.env.REACT_APP_COMPONENT_ENABLE_PRE_CHECK_IN) &&
						<button
							className="btn btn-xl btn-primary"
							onClick={ e => this.props.openPreCheckInModal(e, reservationKey) }
						>
							Pre { hotelLabels.checkIn }
						</button>
					}

					{ !yn(process.env.REACT_APP_COMPONENT_CONFIRMATION_ROOM_CANCEL_POLICIES) &&
						cancellation &&
						<div className="bk-flow-confirmation__room-data-cancellation wrapper row center-xs u-font-medium">
							<div className="row center-xs u-remove-margin u-popover__toggle">
								{ hotelLabels.viewCancellationPolicy } <Icon>info</Icon>

								<div className="u-popover u-popover--bottom">
									<div className="u-popover__content u-remove-margin">
										<h5>{ hotelLabels.cancellationPolicy }</h5>
										<p className="u-remove-margin">{ cancellation }</p>
									</div>
								</div>
							</div>
						</div>
					}

				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
		hotelDescriptiveInfoData: state.hotelDescriptiveInfo.hotelInfo,
		activeCurrencyData: state.activeCurrencyData,
		reservations: state.reservationData.confirmation
	}
}

export default connect(mapStateToProps, null)(BkFlowConfirmationRoomCard)


// WEBPACK FOOTER //
// ./src/components/confirmation/elements/default/BkFlowConfirmationRoomCard.js